export default {
    AVAILABLE_CHART_COLORS:
        {
            BAR: ['ff6384', '4bc0c0', 'ffce56', '36a2eb', 'c14b7a', '53b59f', 'c7d68f', '662d91', '8094c4', 'e7e9ed'],
            LINE: ['ff6384', '4bc0c0', 'ffce56', '36a2eb', 'c14b7a', '53b59f', 'c7d68f', '662d91', '8094c4', 'e7e9ed'],
            RADIAL: ['ff6384', '4bc0c0', 'ffce56', 'e7e9ed', '36a2eb', 'c14b7a', '53b59f', 'c7d68f', '662d91', '8094c4'],
        },
    AVAILABLE_CHART_COLORS_BY_DATA_TYPE: {
        BOOKINGS: '0080d5',
        CANCELLED_BOOKINGS: 'e53e3d',

        SALES_GROSS: '004c7f',
        SALES_PROFIT: '008040',
        SALES_PROFIT_INVERSE: '004c7f',

        INCOME_GROSS: '004c7f',
        INCOME_PROFIT: '008040',
        INCOME_PROFIT_INVERSE: '004c7f',
        INCOME_B2B_PROFIT: '004c7f',
        INCOME_B2C_PROFIT: '008040',
    },
    AVAILABLE_COLORS: [
        'black',
        'primary-lightest',
        'primary-lighter',
        'primary',
        'primary-darker',
        'primary-darkest',
        'info-lightest',
        'info-lighter',
        'info',
        'info-darker',
        'info-darkest',
        'danger-lightest',
        'danger-lighter',
        'danger',
        'danger-darker',
        'danger-darkest',
        'warning-lightest',
        'warning-lighter',
        'warning',
        'warning-darker',
        'warning-darkest',
        'white',
    ],
    AVAILABLE_SIZES: ['xs', 'sm', 'lg'],
    DEFAULT_IMAGE_SEPARATOR: '/assets/separator/viceroy-anguilla_1388092917_4.jpg'
};
